import {CircularProgress, Box, Dialog} from '@mui/material';

const DEFAUL_THICKNESS = 5;

interface AurLoadingIndicatorProps {
  size?: number; // Height and Width of the loader (size * size)
  show?: boolean; // Flag to show or hide the loader
  loaderThickness?: number; // defines the thickness of the loading circular stroke
  className?: string;
  overlay?: boolean;
  isOpen?: boolean;
}

const AurLoadingIndicator: React.FC<AurLoadingIndicatorProps> = ({
  size = 64, // default size (64px * 64px)
  show = true, // default show flag
  loaderThickness = DEFAUL_THICKNESS,
  className,
  overlay = false,
  isOpen = false,
}) => {
  if (!show) return null; // If the show flag is false, don't render the loader
  if (overlay) {
    return (
      <Dialog
        fullScreen={true}
        open={isOpen}
        PaperProps={{className: 'overlay'}}
      >
        <Box>
          <CircularProgress
            size={size}
            color="inherit"
            thickness={loaderThickness}
            className={className}
          />
        </Box>
      </Dialog>
    );
  }

  return (
    <Box className={'aur-loading-indicator-component'}>
      <CircularProgress
        size={size}
        color="inherit"
        thickness={loaderThickness}
        className={className}
      />
    </Box>
  );
};

export default AurLoadingIndicator;
